import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lang",
  "use": "lang-usage",
  "viewBox": "0 0 9 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 9 4\" id=\"lang\"><path d=\"M9.005 0 4.502 3.992-.001 0\" style=\"fill:#000;opacity:.98;fill-rule:evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol